import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context8; _forEachInstanceProperty(_context8 = ownKeys(Object(source), true)).call(_context8, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context9; _forEachInstanceProperty(_context9 = ownKeys(Object(source))).call(_context9, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import invariant from 'invariant';
import uuid from '../utils/uuid';
import { normalizeLocation } from '../utils/history';
/**
 * Initial state of whereabouts redux store
 * @type {Object}
 */

var location = normalizeLocation(window.location);
var initialId = uuid();
export var initialState = {
  current: initialId,
  history: [initialId],
  locations: _defineProperty({}, initialId, {
    id: initialId,
    key: 'init',
    path: location.path,
    hash: location.hash,
    hashQuery: location.hashQuery,
    query: location.query
  })
};
export var REDUX_PUSH = 'whereabouts/PUSH';
export var REDUX_REPLACE = 'whereabouts/REPLACE';
export var REDUX_GO = 'whereabouts/GO';
export var REDUX_UPDATE_BREADCRUMBS = 'whereabouts/UPDATE_BREADCRUMBS';
/**
 * Main reducer for whereabouts actions
 * @param  {Object|undefined} state
 * @param  {Object} action
 * @return {Object}
 */

export function reducer(state, action) {
  if (!state) {
    return initialState;
  }

  switch (action.type) {
    // Push new history item
    case REDUX_PUSH:
      {
        var _context, _state$locations$stat, _state$locations$stat2, _action$payload$state, _action$payload$state2, _action$payload$state3, _context3;

        // Remove the history after the current location
        var currIndex = _findIndexInstanceProperty(_context = state.history).call(_context, function (id) {
          return id === state.current;
        });

        var newHistory = _toConsumableArray(state.history);

        newHistory.length = currIndex + 1; // Current breadcrumbs

        var currentBreadcrumbs = ((_state$locations$stat = state.locations[state.current]) === null || _state$locations$stat === void 0 ? void 0 : (_state$locations$stat2 = _state$locations$stat.state) === null || _state$locations$stat2 === void 0 ? void 0 : _state$locations$stat2.breadcrumbs) || [];
        var breadcrumbs = [];

        if ((_action$payload$state = action.payload.state) !== null && _action$payload$state !== void 0 && _action$payload$state.keepBreadcrumbs) {
          breadcrumbs = currentBreadcrumbs;
        } else if ((_action$payload$state2 = action.payload.state) !== null && _action$payload$state2 !== void 0 && _action$payload$state2.resetBreadcrumbsToIndex) {
          breadcrumbs = _toConsumableArray(currentBreadcrumbs);
          breadcrumbs.length = action.payload.state.resetBreadcrumbsToIndex + 1;
        }

        if ((_action$payload$state3 = action.payload.state) !== null && _action$payload$state3 !== void 0 && _action$payload$state3.addBreadcrumb) {
          var _context2;

          breadcrumbs = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(currentBreadcrumbs), [action.payload.state.addBreadcrumb]);
        } // Create uuid for new route


        var pushId = uuid();
        return _objectSpread(_objectSpread({}, state), {}, {
          current: pushId,
          history: _concatInstanceProperty(_context3 = []).call(_context3, _toConsumableArray(newHistory), [pushId]),
          locations: _objectSpread(_objectSpread({}, state.locations), {}, _defineProperty({}, pushId, _objectSpread(_objectSpread({
            id: pushId
          }, action.payload), {}, {
            state: _objectSpread(_objectSpread({}, action.payload.state || {}), {}, {
              breadcrumbs: breadcrumbs,
              addBreadcrumb: undefined,
              keepBreadcrumbs: undefined,
              resetBreadcrumbsToIndex: undefined
            })
          })))
        });
      }

    case REDUX_REPLACE:
      {
        var _context4;

        var replaceId = uuid();
        return _objectSpread(_objectSpread({}, state), {}, {
          current: replaceId,
          history: _mapInstanceProperty(_context4 = state.history).call(_context4, function (id) {
            return id === state.current ? replaceId : id;
          }),
          locations: _objectSpread(_objectSpread({}, state.locations), {}, _defineProperty({}, replaceId, _objectSpread({
            id: replaceId
          }, action.payload)))
        });
      }

    case REDUX_GO:
      {
        var _context5;

        invariant(action.payload && action.payload.toKey, "You need to define the new location key in 'toKey' of the action payload!");

        var newId = _findInstanceProperty(_context5 = state.history).call(_context5, function (id) {
          return state.locations[id].key === action.payload.toKey;
        });

        var locations = state.locations;
        var history = state.history; // NOTE: in case of the forward event that triggers the POP action
        // with the key of the target hostory entry, if the page has been
        // refreshed since this entry was visited it will cause whereabouts
        // to break cause it cannot find the entry in the state... so we cannot
        // assume the key will always be there, so instead we just push the given
        // location!

        if (!newId) {
          var _context6, _context7;

          var _currIndex = _findIndexInstanceProperty(_context6 = state.history).call(_context6, function (id) {
            return id === state.current;
          });

          var _newHistory = _toConsumableArray(state.history);

          _newHistory.length = _currIndex + 1; // Create uuid for new route

          newId = uuid();
          history = _concatInstanceProperty(_context7 = []).call(_context7, _toConsumableArray(_newHistory), [newId]);
          locations = _objectSpread(_objectSpread({}, locations), {}, _defineProperty({}, newId, action.payload.location));
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          current: newId,
          history: history,
          locations: locations
        });
      }

    case REDUX_UPDATE_BREADCRUMBS:
      {
        var id = action.payload.id || state.current;

        var _locations2 = _objectSpread(_objectSpread({}, state.locations), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, state.locations[id]), {}, {
          state: _objectSpread(_objectSpread({}, state.locations[id].state || {}), {}, {
            breadcrumbs: action.payload.breadcrumbs
          })
        })));

        return _objectSpread(_objectSpread({}, state), {}, {
          locations: _locations2
        });
      }
    // Fallback

    default:
      return state;
  }
}